import { createFileRoute, redirect } from "@tanstack/react-router";

import { Centered } from "@/components/ui/container";
import { apiUtils } from "@/context/query";

export const Route = createFileRoute("/_auth/_app/views/$id")({
  params: {
    parse: (params) => ({
      id: Number(params.id),
    }),
  },

  loader: async ({ params }) => {
    // TODO: is this needed? Does beforeLoad not re-run on router.invalidate()?
    const views = await apiUtils.accession.views.list.fetch();
    const view = views.find((v) => v.id === params.id);

    if (!view) {
      throw redirect({ to: "/accessions" });
    }

    return { view };
  },

  notFoundComponent: () => (
    <Centered>
      <div className="text-lg font-medium">View not found</div>
    </Centered>
  ),
});
